import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import { Cancel } from '../../media/images/Cancel';
import { Datatablestyle } from './utils/Constant';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import { getJobsStart } from '../Job/jobStarter/redux/jobStarterSlice';
import { JobTableColumns } from '../Job/jobStarter/utils/constants';
import { JobsTableData } from '../Job/jobStarter/utils/types';
import { formatJobsData } from '../Job/jobStarter/utils/helper';
import BidByJobModal from './BidByJobModal';
import { defaultPageSize } from '../../utils/Constant';

interface IBidReportModal {
  open: boolean;
  handleClose: () => void;
  selectedUnit: string;
}

export default function JobsListModal({
  open, handleClose, selectedUnit,
}: IBidReportModal) {
  const dispatch = useDispatch();
  const { totalEntries, isLoading, jobs } = useSelector((state: RootState) => state.jobsReducer);
  const [selectedJob, setSelectedJob] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [searchParam, setSearchParam] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const handleData = () => {
    const payload = {
      page: pageNumber,
      searchQuery: searchParam,
      rowsPerPage: pageSize,
      sortCol,
      sortDir,
    };

    dispatch(getJobsStart(payload));
  };

  useEffect(() => {
    handleData();
  }, [pageNumber, pageSize, searchParam, sortCol, sortDir]);
  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleDetails = (id: string) => {
    setSelectedJob(id);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Datatablestyle}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Job List
            </div>
            <div className="cancel-icon" style={{ cursor: 'pointer' }} onClick={() => handleClose()}>
              <Cancel />
            </div>
          </div>
          <DataTable<JobsTableData>
            data={formatJobsData(jobs, true)}
            columns={JobTableColumns}
            totalRecords={totalEntries}
            page={pageNumber}
            setPage={(e) => { (setPageNumber(e)); }}
            rowsPerPage={pageSize}
            setRowsPerPage={(e) => { (setPageSize(e)); }}
            searchQuery={searchParam}
            setSearchQuery={(e) => { (setSearchParam(e)); (setPageNumber(1)); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPageNumber(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPageNumber(1); }}
            handleData={handleData}
            handleViews={handleDetails}
            handleDataFromComponent
          />
        </Box>
      </Modal>
      {selectedJob?.length > 0 && (
      <BidByJobModal
        open={selectedJob}
        handleClose={() => setSelectedJob('')}
        selectedUnit={selectedUnit}
        handleSuccess={handleClose}
      />
      )}
    </>
  );
}
